/**
 * Small "vX.Y.Z" pill in the header. Click to see what changed recently.
 *
 * __APP_VERSION__ is injected at build time from web/package.json (see vite.config.js)
 * so the pill always matches whatever was actually built and deployed — bumping the
 * version is the only thing you need to do for this label to update.
 */
import { useState } from 'react';
import { CHANGELOG } from '../lib/changelog';

export default function VersionPill() {
  const [open, setOpen] = useState(false);
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-100 px-3 py-[5px] font-mono text-xs text-ink hover:border-accent-500 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300"
        title="What's new"
      >
        {/* A status dot, not decoration: green here means "this is the build you are looking at". */}
        <span aria-hidden="true" className="h-[7px] w-[7px] rounded-full bg-accent-500" />
        v{version}
      </button>

      {open && (
        <>
          {/* Click-away catcher */}
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-20 mt-2 w-96 max-w-[90vw] rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 text-left shadow-xl">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-semibold text-firm-700 dark:text-firm-100">What's new</h3>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-xs text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300"
              >
                Close
              </button>
            </div>
            <div className="mt-3 max-h-96 space-y-4 overflow-auto pr-1">
              {CHANGELOG.map((entry) => (
                <div key={entry.version}>
                  <p className="text-xs font-semibold text-slate-700 dark:text-slate-200">
                    v{entry.version}{' '}
                    <span className="font-normal text-slate-400 dark:text-slate-500">· {entry.date}</span>
                  </p>
                  <ul className="mt-1 list-disc space-y-1 pl-5 text-xs text-slate-600 dark:text-slate-300">
                    {entry.highlights.map((h, i) => (
                      <li key={i}>{h}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
